<template>
  <div class="app-window app-page__wrapper">
    <div class="app-window__title app-page__wrapper">
      <div class="app-page__content">
        Partners
      </div>
    </div>
    <router-link tag="div" to="/" class="app-window__close-button"></router-link>
    <div class="app-page__content app-page__padding">
      <div class="partners-view__partners-logos">
        <div class="partners-view__partner-logo">
          <img alt="Bertelsmann Foundation's Logo" src="../assets/bertelsmann-logo.png" />
        </div>
        <div class="partners-view__partner-logo">
          <img alt="Humanity in Action's Logo" src="../assets/HIA_Logo-white.png" />
        </div>
      </div>
      <p class="partners-view__title">
        <span class="highlight">Bertelsmann Foundation</span>
      </p>
      <section class="partners-view__text flex columns">
        <div class="column">
          <p>
            The Bertelsmann Foundation, established in 2008, is the North American arm of the Germany-Based Bertelsmann Stiftung. It was created to promote and strengthen the transatlantic relationship. Through its research, debate forums and multimedia tools, the Foundation provides analysis and solutions to the most pressing economic, political and social challenges impacting the United States and Europe.
          </p>
        </div>
      </section>
      <p class="partners-view__title">
        <span class="highlight">Humanity in Action</span>
      </p>
      <section class="partners-view__text flex columns">
        <div class="column">
          <p>
            Humanity in Action is an international organization that educates, inspires action and connects a network of university students and young professionals committed to the values of pluralism, liberal democracy, social justice, human rights and civic engagement in their own communities and around the world.
          </p>
          <p>
            Humanity in Action has educated over 2,000 young leaders who now form a unique transatlantic network. Humanity in Action’s annual Fellowship Program brings together about 160 European and US college and university students, as well as young professionals from Bosnia and Herzegovina, Denmark, France, Greece, Germany, Poland, the Netherlands, Ukraine and the United States.
          </p>
          <p>
            Apart from the annual Fellowship Program, Humanity in Action maintains an international alumni network of students, young professionals, established leaders and experts in various fields, providing them with a range of ongoing educational and professional opportunities.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<style lang="scss">
.partners-view {
  &__title {
    font-size: 2em;
    font-weight: 700;
    letter-spacing: 2.92px;
    line-height: 50px;
    text-transform: uppercase;
    padding: 32px 0;

    .highlight {
      color: $colors-orange;
      letter-spacing: 3px;
    }
  }

  &__text {
    font-weight: 500;
    line-height: 30px;
  }

  &__partners-logos {
    text-align: center;
    border-bottom: 1px solid #3e3e3e;
  }

  &__partner-logo {
    display: block;

    img {
      max-width: 160px;
      padding: 0 0 48px 0;
    }

    @include media-breakpoint-large {
      display: inline-block;

      & + & {
        margin-left: 80px;
      }

      img {
        max-width: 240px;
      }
    }
  }
}
</style>

<script>
const description = 'Bertelsmann Foundation: The Bertelsmann Foundation, established in 2008, is the North American arm of the Germany-Based Bertelsmann Stiftung. It was created to promote and strengthen the transatlantic relationship. Through its research, debate forums and multimedia tools, the Foundation provides analysis and solutions to the most pressing economic, political and social challenges impacting the United States and Europe. Humanity in Action: Humanity in Action is an international organization that educates, inspires action and connects a network of university students and young professionals committed to the values of pluralism, liberal democracy, social justice, human rights and civic engagement in their own communities and around the world.'
export default {
  name: 'partnersView',
  metaInfo () {
    return {
      title: 'Partners | How To Fix Democracy',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: description
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Partners | How To Fix Democracy'
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: description
        }
      ]
    }
  },
  mounted () {
    this.$store.commit('setHomepageVideoEffect', false)
    this.$store.commit('setNavigation', true)
  }
}
</script>
